export const getClasses = (...classes: string[]): string => {
  return classes.join(" ");
};

const getDate = (date: Date) => {
  return new Date(date.toDateString());
};

export const getDaysCount = (date1: number, date2: number) => {
  // The number of milliseconds in one day.
  const ONE_DAY = 1000 * 60 * 60 * 24;

  // Calculate the difference in days.
  const differenceMs = Math.abs(
    getDate(new Date(date1)).getTime() - getDate(new Date(date2)).getTime()
  );

  // Convert back to days and return
  return Math.round(differenceMs / ONE_DAY) + 1;
};
